import { useTheme } from "@mui/material/styles";
import { useMatchQuery } from "./useMatchQuery.js";
const useIsDesktopLarge = ()=>{
    const theme = useTheme();
    return useMatchQuery(theme.breakpoints.up('lg'));
};
export { useIsDesktopLarge };
